import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  ${tw`inline-block py-4 px-14 border text-center no-underline cursor-pointer uppercase text-sm tracking-widest`};
  transition: color 0.2s, background-color 0.2s, border-color 0.2s;
`
